import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { CampaignAdgroupSelectorEdm } from './campaign-adgroup-selector-edm';

/**
 * the backbone view for the react campaign adgroup selector
 * campaign format: {onFetch, pageSize}
 * adgroup format: {onFetch, pageSize}
 */
export class CampaignAdgroupSelectorEdmView extends Backbone.View {
  initialize({
    i18n, scope, isCampaignMode, withDropdownMenu,
    campaignFilterCustomizer, value,
  }) {
    this.i18n = i18n;
    this.scope = scope;
    this.onApply = this.onApply.bind(this);
    this.onSelectCancel = this.onSelectCancel.bind(this);
    this.isCampaignMode = isCampaignMode;
    this.withDropdownMenu = withDropdownMenu;
    this.campaignFilterCustomizer = campaignFilterCustomizer;
    this.value = value;
  }

  /**
   * should trigger event to notify outter component
   * @param {object} selectedItem - the item selected
   * @returns {undefined} update the state with fetch result
   */
  onApply(selectedItem) {
    this.trigger('on-apply', selectedItem);
  }

  /**
   * should trigger event to notify outter component
   * @param {object} selectedItem - the item selected
   * @returns {undefined} update the state with fetch result
   */
  onSelectCancel() {
    this.trigger('on-select-cancel');
  }

  render() {
    ReactDOM.render(
      (
        <CampaignAdgroupSelectorEdm
          i18n={this.i18n}
          scope={this.scope}
          onApply={this.onApply}
          onSelectCancel={this.onSelectCancel}
          isCampaignMode={this.isCampaignMode}
          withDropdownMenu={this.withDropdownMenu}
          campaignFilterCustomizer={this.campaignFilterCustomizer}
          value={this.value}
        />
      ), this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
